import jwt from 'jsonwebtoken';

/** Id token key */
const ID_TOKEN_KEY = 'idToken';

/** Refresh token key */
const REFRESH_TOKEN_KEY = 'refreshToken';

/** Tenant key */
const TENANT_KEY = 'tenant';

/** Tenants key */
const TENANTS_KEY = 'tenants';

/** Filters key */
const CONTROLLERS_KEY = 'controllers';

/** Local Storage Item */
class StorageItem {
  key: string;

  type: 'local' | 'session';

  isJwt: boolean;

  constructor(key: string, type: 'local' | 'session' = 'local', isJwt: boolean = false) {
    this.key = key;
    this.type = type;
    this.isJwt = isJwt;
  }

  private getStorage() {
    return this.type === 'local' ? localStorage : sessionStorage;
  }

  get() {
    return this.getStorage().getItem(this.key);
  }

  set(item: string) {
    this.getStorage().setItem(this.key, item);
  }

  remove() {
    this.getStorage().removeItem(this.key);
  }

  expired(addTime: number = 0) {
    if (!this.isJwt) {
      throw new Error('Not a JWT Token');
    }

    const token = this.get();
    if (!token) {
      throw new Error('Token is missing');
    }

    const decodedToken = jwt.decode(token, { complete: true });
    const now = new Date();
    const time = (now.getTime() + addTime) / 1000;
    return time > decodedToken?.payload?.exp;
  }
}

export const storage = {
  idToken: new StorageItem(ID_TOKEN_KEY, 'local', true),
  refreshToken: new StorageItem(REFRESH_TOKEN_KEY, 'local', true),
  tenant: new StorageItem(TENANT_KEY, 'local'),
  tenants: new StorageItem(TENANTS_KEY, 'local'),
  controllers: new StorageItem(CONTROLLERS_KEY, 'session'),
  clear: () => {
    storage.idToken.remove();
    storage.refreshToken.remove();
    storage.tenant.remove();
    storage.tenants.remove();
    storage.controllers.remove();
  },
};
